import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import {
    DEVICE_CONFIGURATION_TABS,
    DeviceConfigurationTabs,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-device-configuration-dashboard/settings-device-configuration-dashboard.constants';
import {
    DevicesConfigurationDashboardHeaderStyled,
    DevicesConfigurationDashboardHeaderStyledPocTabs,
    DevicesConfigurationDashboardTab,
    DevicesConfigurationImage,
    DevicesConfigurationInfoBodyText,
    DevicesConfigurationInfoHeaderStyled,
    DevicesConfigurationInfoSection,
} from './settings-devices-configuration-dashboard-header.style';

interface SettingsDevicesConfigurationDashboardHeaderProps {
    title: string;
    selectedTab: DeviceConfigurationTabs;
    onTabChange: (value: DeviceConfigurationTabs) => void;
}

export const SettingsDevicesConfigurationDashboardHeader = ({
    title,
    selectedTab,
    onTabChange,
}: SettingsDevicesConfigurationDashboardHeaderProps) => {
    const { t } = useTranslation();
    return (
        <DevicesConfigurationDashboardHeaderStyled>
            <DevicesConfigurationInfoHeaderStyled>
                <DevicesConfigurationImage
                    src={`/devices/${title}.png`}
                    fallbackSrc="/devices/fallback.png"
                    alt={`${title}`}
                />
                <DevicesConfigurationInfoSection>
                    <PocTypography variant="title5">{title}</PocTypography>
                    <DevicesConfigurationInfoBodyText>{title}</DevicesConfigurationInfoBodyText>
                </DevicesConfigurationInfoSection>
            </DevicesConfigurationInfoHeaderStyled>
            <DevicesConfigurationDashboardHeaderStyledPocTabs
                elevated="none"
                size="small"
                value={selectedTab}
                onValueChange={(ev) => onTabChange(ev.detail as DeviceConfigurationTabs)}
            >
                <DevicesConfigurationDashboardTab value={DEVICE_CONFIGURATION_TABS.CONFIGURATIONS}>
                    {t('settings.devices.device-settings.title')}
                </DevicesConfigurationDashboardTab>

                <DevicesConfigurationDashboardTab value={DEVICE_CONFIGURATION_TABS.STATUS_TRACK}>
                    {t('settings.devices.device-settings-configuration-status-tracking.tab.title')}
                </DevicesConfigurationDashboardTab>

                <DevicesConfigurationDashboardTab value={DEVICE_CONFIGURATION_TABS.CUSTOM_ALARMS}>
                    {t('settings.devices.custom-alarms.tab.title')}
                </DevicesConfigurationDashboardTab>
            </DevicesConfigurationDashboardHeaderStyledPocTabs>
        </DevicesConfigurationDashboardHeaderStyled>
    );
};
